<template>
    <LayoutSub className="solution">
        <div class="tab_menu">
            <button @click="changeContent('waiting')"
                :class="activeContent === 'waiting' ? 'selected' : ''">웨이팅</button>
            <button @click="changeContent('did')" :class="activeContent === 'did' ? 'selected' : ''">고객 호출(DID)</button>
            <button @click="changeContent('kds')" :class="activeContent === 'kds' ? 'selected' : ''">주문서
                관리(KDS)</button>
        </div>
        <SubSection class="content p-0" v-if="activeContent === 'waiting'">
            <StickyContainer title="EasyWaiting"
                subText="고객의 휴대폰 번호 입력으로 입장 대기 순서를 손쉽게<br>관리할 수 있으며 대형 디스플레이와 연동하여 매장 환경을<br>만들 수 있습니다."
                :leftItems="waitingLeftItems" :rightItems="waitingRightItems">
            </StickyContainer>
        </SubSection>
        <SubSection class="content p-0" v-else-if="activeContent === 'did'">
            <StickyContainer title="EasyDID" subTitle="Digital Information Display"
                subText="별도의 진동벨 관리 없이 알림톡을 통해 주문 접수 내역 공유와<br>주문번호 호출이 가능하며 메뉴판, 미디어 광고 등<br>다양한 서비스를 융합하여 사용할 수 있습니다."
                :leftItems="didLeftItems" :rightItems="didRightItems">
            </StickyContainer>
        </SubSection>
        <SubSection class="content p-0" v-else>
            <StickyContainer title="EasyKDS" subTitle="Kitchen Display System"
                subText="주방주문자동화 솔루션으로 주방 운영 효율성 제고 및<br>Paperless 매장 구성<br>안드로이드 제공" :leftItems="kdsLeftItems"
                :rightItems="kdsRightItems">
            </StickyContainer>
        </SubSection>
    </LayoutSub>
</template>

<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import SubSection from '@/components/SubSection.vue';
import StickyContainer from '@/components/StickyContainer.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        StickyContainer
    },
    data() {
        return {
            activeContent: 'waiting',
            // WAITING 관련 데이터
            waitingLeftItems: [
                { text: "POS내 관리자 기능 내제화", active: true },
                { text: "관리자용 템플릿", active: false },
                { text: "고객용 태블릿", active: false },
                { text: "EasyDID 연동", active: false },
            ],
            waitingRightItems: [
                {
                    img: require("@/assets/waiting_img_01.png"),
                    title: "POS내 관리자 기능 내제화",
                    description: "안드로이드/윈도우 포스에 내재화 되어 있어 안드로이드 장비 하나만 추가하여 바로 사용 가능",
                },
                {
                    img: require("@/assets/waiting_img_02.png"),
                    title: "관리자용 태블릿",
                    description:
                        "대기 고객 정보를 한눈에 확인하고 제어하는 관리자용 태블릿",
                },
                {
                    img: require("@/assets/waiting_img_03.png"),
                    title: "고객용 태블릿",
                    description:
                        "대기고객의 정보를 입력받는 고객용 태블릿 6가지 색상 테마 제공",
                },
                {
                    img: require("@/assets/waiting_img_06.png"),
                    title: "EasyDID 연동",
                    description:
                        "EasyDID를 활용하여 EasyWaiting & EasyDID 자동 동기화 가능<br />EasyDID(대기번호 호출버전)와 연동을 통해 대기번호 디스플레이 송출이 가능합니다.<br /> (EasyDID는 ①주문번호 호출, ②대기번호 호출 2가지 버전이 있음) ",
                }
            ],
            // DID 관련 데이터
            didLeftItems: [
                { text: "3가지 타입의 구동화면 제공", active: true },
                { text: "웨이팅 정보 표출", active: false },
                { text: "대기번호 표출", active: false },
                { text: "광고 표출 기능", active: false },
            ],
            didRightItems: [
                {
                    img: require("@/assets/did_img_01.png"),
                    title: "3가지 타입의 구동화면 제공",
                    description: "가맹점 환경에 따라서 준비 중 표시 가능 / 준비 중 화면 미사용 시 광고 동영상 및 이미지를 삽입하여 광고 플랫폼으로 활용 가능",
                },
                {
                    img: require("@/assets/did_img_02.png"),
                    title: "웨이팅 정보 표출",
                    description:
                        "EasyDID를 활용하여 가맹점의 웨이팅 정보 자동 동기화 가능",
                },
                {
                    img: require("@/assets/did_img_03.png"),
                    title: "대기번호 표출",
                    description:
                        "EasyDID를 활용하여 대기고객의 대기번호 호출 기능 제공",
                },
                {
                    img: require("@/assets/did_img_04.png"),
                    title: "광고 표출 기능",
                    description:
                        "가맹점 요구에 맞춰 광고 이미지 및 동영상 송출 기능 제공",
                }
            ],
            // KDS 관련 데이터
            kdsLeftItems: [
                { text: "주방주문 목록 표시 화면 조정", active: true },
                { text: "주방주문 조리 단계별 관리 가능", active: false },
                { text: "주문번호 호출 기능", active: false }
            ],
            kdsRightItems: [
                {
                    img: require("@/assets/kds_img_01.png"),
                    title: "주방주문 목록 표시 화면 조정",
                    description: "최대 4x2의 8개 주문 데이터를 한눈에 파악 가능<br>픽업대에서 사용하는 제공모드와 주방에서 사용하는 주방모드 분리하여 사용 가능",
                },
                {
                    img: require("@/assets/kds_img_02.png"),
                    title: "주방주문 조리 단계별 관리 가능",
                    description:
                        "조리개시부터 조리완료, 요리제공까지 주문을 체계적으로 관리 가능",
                },
                {
                    img: require("@/assets/kds_img_03.png"),
                    title: "주문번호 호출 기능",
                    description:
                        "주문번호에 대해서 알림톡, 진동벨, DID 등 다양한 수단으로 고객호출 가능",
                }
            ],
        }
    },
    methods: {
        changeContent(content) {
            this.activeContent = content;
        },
    }
}
</script>